import * as React from 'react';
const GridComponent = React.lazy(() => import('./Grid').then(({ Grid }) => ({ default: Grid })));
export function LazyGrid(props) {
    return (React.createElement(React.Suspense, { fallback: props.fallback },
        React.createElement(GridComponent, Object.assign({}, props))));
}
